import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import '@fs/react-scripts/polyfills'
import * as Sentry from '@sentry/browser'
import { AdminRoot, FrontierBaseProviders } from '@fs/zion-root'
import GlobalFooter from '@fs/zion-footer'
// import Root from '@fs/zion-root'
import { AppLayout } from '@fs/zion-ui'
import { Router } from '@fs/zion-router'
import { appPath, sentryDSN, mergeSentryConfig } from '@fs/zion-config'

import { NoticeLoading } from '@fs/zion-icon'
import useHasAdminPermissions from './hooks/useHasAdminPermissions'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import './locales'

// Enable local feature flag development using the file "dev.flags.js"
// If that file exports anything truthy it will initialize feature flags in localhost mode
// and use the flags defined in that file, instead of flags defined in split.
const mockFlags = process.env.NODE_ENV === 'development' ? import('./dev.flags').then((m) => m.default) : undefined
const mockActivities =
  process.env.NODE_ENV === 'development' ? import('./dev.activities').then((m) => m.default) : undefined

// initialize Sentry for the app
if (sentryDSN) {
  // pass Sentry overrides to mergeSentryConfig
  Sentry.init(
    mergeSentryConfig({
      dsn: sentryDSN,
    })
  )
}

// Here we pass the mounted app path from the server to the client.
const base = appPath ? new URL(appPath).pathname : ''
const nav = [
  {
    title: 'Dashboard',
    to: '/',
  },
  {
    title: 'Guides',
    to: 'https://developers.familysearch.org/main/docs/getting-started#/',
  },
  {
    title: 'API Reference',
    to: 'https://developers.familysearch.org/main/reference/api-reference-guide#/',
  },
  {
    title: 'Change Log',
    to: 'https://developers.familysearch.org/main/changelog#/',
  },
  {
    title: 'Help',
    to: 'https://developers.familysearch.org/main/docs/developer-support#/',
  },
]
const adminNav = [
  ...nav,
  {
    title: 'Admin',
    to: '/admin',
  },
]

// add any app logic here, languages and translations are configured and available here
const FrontierWrapper = () => {
  const isAdminPage = window.location.href.includes('admin')
  const { hasPermission, status, error } = useHasAdminPermissions()

  return (
    <Router basename={base}>
      <AdminRoot
        analytics
        header={{
          appName: isAdminPage ? 'Developer Admin' : 'Developer',
          baseUrl: '/',
          nav: hasPermission && status === 'loaded' && !error ? adminNav : nav,
          signOutReturnUrl: `https://developers.familysearch.org`,
        }}
        footerContent={<GlobalFooter />}
      >
        <AppLayout fullWidth>
          <App />
        </AppLayout>
      </AdminRoot>
    </Router>
  )
}

// Do not make changes to FrontierRoot, all changes should be made to FrontierWrapper
const FrontierRoot = () => (
  <React.StrictMode>
    <Suspense fallback={<NoticeLoading />}>
      <FrontierBaseProviders mockFlags={mockFlags} mockActivities={mockActivities}>
        <FrontierWrapper />
      </FrontierBaseProviders>
    </Suspense>
  </React.StrictMode>
)

ReactDOM.render(<FrontierRoot />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()
